import { render, staticRenderFns } from "./CustomerCoupons.vue?vue&type=template&id=7eeeefae&"
import script from "./CustomerCoupons.vue?vue&type=script&lang=js&"
export * from "./CustomerCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports